// extracted by mini-css-extract-plugin
module.exports = {"emptyCell":"plain_emptyCell__UeSTK","compact":"plain_compact__B9ePk"};